function convertFirstSpaceToNonBreakingSpace(str) {
  return str.replace(' ', '\u00A0');
}

export { convertFirstSpaceToNonBreakingSpace };
